import { GoalImageProps } from './index';

export const IMAGE_LOADER_SECONDARY_COLOR = '#EAECF1';

// Ensure list matches data from b4c/app/models/goal.rb
export const ORDERED_IMAGE_TYPES: Exclude<GoalImageProps['name'], 'custom'>[] = [
  'lifering',
  'tree',
  'car',
  'coin',
  'wedding',
  'present',
  'parasol',
  'home',
  'apple',
  'baby',
  'business',
  'charity',
  'bandaid',
  'plane',
  'plant',
  'watering_can',
  'cap',
];
